/* eslint-disable import/prefer-default-export */

import CheckboxGroup from '@components/ui/formElements/CheckboxGroup'
import {
  Values,
  ReasonListItemField,
  ReasonListItemFieldValue
} from '@components/returns/types'
import additionalFieldsStyles from './additionalFields.module.scss'
import { ReasonDropdown } from './ReasonDropdown'
import { Radios } from './Radios'
import { RawTextareaField } from '@components/ui/formElements/form/Textarea/RawTextarea'
import { useState } from 'react'

export type AdditionalReasonFieldProps = {
  values: Values
  field?: ReasonListItemField
  handleOnAdditionalReasonSelection: (selection: string[]) => void
}

function TextareaField({
  handleOnAdditionalReasonSelection,
  firstField
}: {
  handleOnAdditionalReasonSelection: (selection: string[]) => void
  firstField: ReasonListItemFieldValue
}) {
  const [textareValue, setTextareaValue] = useState('')

  const handleTextare = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTextareaValue(e.target.value)
    handleOnAdditionalReasonSelection([
      `${firstField?.label} : ${e.target.value}`
    ])
  }

  return (
    <RawTextareaField
      id={firstField?.id}
      name={firstField.label}
      value={textareValue}
      placeholder="Type your message here"
      onChange={handleTextare}
    />
  )
}

function AdditionalReasonField({
  field,
  values,
  handleOnAdditionalReasonSelection
}: AdditionalReasonFieldProps) {
  if (!field) return null
  const firstField = field.values[0]

  return (
    <div className={additionalFieldsStyles.returnsForm__additionalFields}>
      {field?.type === 'radio' && (
        <div
          className={
            additionalFieldsStyles.returnsForm__additionalFieldsRadiosWrapper
          }
        >
          <p
            className={
              additionalFieldsStyles.returnsForm__additionalFieldsRadiosLabel
            }
          >
            {field.label}
          </p>
          <Radios
            field={field}
            values={values}
            handleOnAdditionalReasonSelection={
              handleOnAdditionalReasonSelection
            }
          />
        </div>
      )}
      {field?.type === 'checkbox' && (
        <CheckboxGroup
          fields={field.values.map(item => ({
            ...item,
            isChecked: values.reason_detail?.includes(item.id) || false
          }))}
          onChange={selection =>
            handleOnAdditionalReasonSelection(
              selection.filter(item => item.isChecked).map(item => item.id)
            )
          }
        />
      )}
      {field?.type === 'dropdown' && (
        <ReasonDropdown
          field={field}
          values={values}
          handleOnAdditionalReasonSelection={handleOnAdditionalReasonSelection}
        />
      )}
      {field?.type === 'text' && (
        <TextareaField
          handleOnAdditionalReasonSelection={handleOnAdditionalReasonSelection}
          firstField={firstField}
        />
      )}
    </div>
  )
}

export default AdditionalReasonField
